// Matches the .reference.color-N and .text.color-N values in colors.css
// so they can be used in code by index as well.

export default [
    '#048845',
    '#8490C8',
    '#BF61A5',
    '#EE3124',
    '#FCD700',
    '#5555FF',
    '#9ACA3C',
    '#9F78AC',
    '#F88084',
    '#F5A4C7',
    '#CEE6C1',
    '#FFFF00',
    '#6FC7B6',
    '#D5A768',
    '#D4D4D4',
]
